var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-jumbotron",
        {
          attrs: {
            header: "Forget Password",
            lead:
              "Please fill up the form and wait for the email of resetting password"
          }
        },
        [
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "3" } }, [_vm._v("Username")]),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c("b-form-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.userForgetPasswordInfo.username,
                      callback: function($$v) {
                        _vm.$set(_vm.userForgetPasswordInfo, "username", $$v)
                      },
                      expression: "userForgetPasswordInfo.username"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "3" } }, [_vm._v("Personal Email")]),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c("b-form-input", {
                    attrs: { type: "email" },
                    model: {
                      value: _vm.userForgetPasswordInfo.perEmail,
                      callback: function($$v) {
                        _vm.$set(_vm.userForgetPasswordInfo, "perEmail", $$v)
                      },
                      expression: "userForgetPasswordInfo.perEmail"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "3" } }, [_vm._v("NRIC/FIN No.")]),
              _c(
                "b-col",
                { attrs: { sm: "2" } },
                [
                  _c("b-form-select", {
                    staticClass: "mb-3",
                    attrs: { options: _vm.idType },
                    model: {
                      value: _vm.userForgetPasswordInfo.idType,
                      callback: function($$v) {
                        _vm.$set(_vm.userForgetPasswordInfo, "idType", $$v)
                      },
                      expression: "userForgetPasswordInfo.idType"
                    }
                  })
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { sm: "4" } },
                [
                  _c("b-form-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.userForgetPasswordInfo.nricFin,
                      callback: function($$v) {
                        _vm.$set(_vm.userForgetPasswordInfo, "nricFin", $$v)
                      },
                      expression: "userForgetPasswordInfo.nricFin"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-button",
            {
              attrs: { variant: "primary" },
              on: {
                click: function($event) {
                  _vm.userForgetPassword()
                }
              }
            },
            [_vm._v("Send Reset Email")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-517359c3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-517359c3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/ForgetPassword.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-517359c3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/ForgetPassword.vue
// module chunks = 7